var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.992 12.5865C13.3849 12.7175 13.8097 12.5051 13.9406 12.1122C14.0716 11.7192 13.8593 11.2945 13.4663 11.1635L13.2291 11.875L12.992 12.5865ZM10.4166 10.9375H9.66663C9.66663 11.2603 9.8732 11.5469 10.1795 11.649L10.4166 10.9375ZM11.1666 7.01739C11.1666 6.60318 10.8308 6.26739 10.4166 6.26739C10.0024 6.26739 9.66663 6.60318 9.66663 7.01739H10.4166H11.1666ZM13.2291 11.875L13.4663 11.1635L10.6538 10.226L10.4166 10.9375L10.1795 11.649L12.992 12.5865L13.2291 11.875ZM10.4166 10.9375H11.1666V7.01739H10.4166H9.66663V10.9375H10.4166ZM17.9166 10H17.1666C17.1666 13.7279 14.1445 16.75 10.4166 16.75V17.5V18.25C14.973 18.25 18.6666 14.5563 18.6666 10H17.9166ZM10.4166 17.5V16.75C6.6887 16.75 3.66663 13.7279 3.66663 10H2.91663H2.16663C2.16663 14.5563 5.86028 18.25 10.4166 18.25V17.5ZM2.91663 10H3.66663C3.66663 6.27208 6.6887 3.25 10.4166 3.25V2.5V1.75C5.86028 1.75 2.16663 5.44365 2.16663 10H2.91663ZM10.4166 2.5V3.25C14.1445 3.25 17.1666 6.27208 17.1666 10H17.9166H18.6666C18.6666 5.44365 14.973 1.75 10.4166 1.75V2.5Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapClock);
export default __webpack_public_path__ + "static/media/map-clock.b26674d0d4a273587af55b32b19aca6d.svg";
export { ForwardRef as ReactComponent };